export const validationRulesNew = {
    firstName: {
        required: true,
        maxLength: 32,
        noWhiteSpace: true
    },
    lastName: {
        required: true,
        maxLength: 32,
        noWhiteSpace: true
    },
    dob: {
        required: true,
        format: /^\d{2}\/\d{2}\/\d{4}$/,
        notInTheFuture: true,
        validDateFormat: true
    },
    specialty: {
        required: true
    },
    homeAddressLine1: {
        required: true,
        maxLength: 40,
        noWhiteSpace: true,
        format: /^[A-Za-z0-9#'\$\/\.\- ]{1,40}$/
    },
    homeCity: {
        required: true,
        maxLength: 35,
        noWhiteSpace: true,
        format: /^[a-zA-Z .\-']{1,35}$/
    },
    homeState: {
        required: true,
        maxLength: 2
    },
    homeZipCode: {
        required: true,
        format: /^[0-9]{5}([0-9]{4})?$/
    },
    homePhone: {
        required: true,
        format: /^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/,
        isNotRepeated: true //Should has format of NOT repeated numbers
    },
    ssn: {
        required: true,
        format: /^(?:\d{3}-\d{2}|\*{3}-\*{2})-\d{4}$/
    },
    email: {
        required: true,
        maxLength: 50,
        format: /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/
    },
    degree: {
        required: true,
        maxLength: 35,
        noWhiteSpace: true
    },
    // taxId: {
    //     required: true,
    //     format: /^[0-9]{9}$/
    // }
};


// WEBPACK FOOTER //
// ./src/components/Provider/validationRulesNew.ts